const localeValues = {
  ko: {
    clear: "\uCD08\uAE30\uD654",
    datePlaceholder: "\uB0A0\uC9DC \uC785\uB825",
    modeToggleSwitchLabel: "\uAE30\uAC04 \uC785\uB825",
    startDatePlaceholder: "\uC2DC\uC791\uC77C \uC785\uB825",
    endDatePlaceholder: "\uC885\uB8CC\uC77C \uC785\uB825",
    yearMonthPlaceholder: "\uC5F0\uC6D4 \uC785\uB825",
    startYearMonthPlaceholder: "\uC2DC\uC791 \uC5F0\uC6D4 \uC785\uB825",
    endYearMonthPlaceholder: "\uC885\uB8CC \uC5F0\uC6D4 \uC785\uB825",
    modeToggleText: "\uAE30\uAC04 \uC785\uB825",
    invalidDateInputErrorMessage: "\uC62C\uBC14\uB978 \uB0A0\uC9DC\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
    invalidRangeInputErrorMessage: "\uC62C\uBC14\uB978 \uAE30\uAC04\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
    notAllowedDateErrorMessage: "\uC120\uD0DD\uD560 \uC218 \uC5C6\uB294 \uB0A0\uC9DC\uC5D0\uC694.",
    notAllowedMonthErrorMessage: "\uC120\uD0DD\uD560 \uC218 \uC5C6\uB294 \uC6D4\uC774\uC5D0\uC694."
  },
  en: {
    clear: "Clear",
    datePlaceholder: "Enter date",
    modeToggleSwitchLabel: "Enter a period",
    startDatePlaceholder: "Enter start date",
    endDatePlaceholder: "Enter end date",
    yearMonthPlaceholder: "Enter year and month",
    startYearMonthPlaceholder: "Enter start year and month",
    endYearMonthPlaceholder: "Enter end year and month",
    invalidDateInputErrorMessage: "Enter valid date.",
    invalidRangeInputErrorMessage: "Enter valid period.",
    notAllowedDateErrorMessage: "It's a date you can't choose.",
    notAllowedMonthErrorMessage: "It's a month you can't choose."
  }
};

export { localeValues };
//# sourceMappingURL=localeValues.mjs.map
